export enum EquipmentTypeEnums {
  All = 0,
  Equipment = 1,
  Parts = 2,
}

export enum EquipmentTypeStringEnums {
  "All" = 0,
  "Wholegoods" = 1,
  "Parts" = 2,
}
